export default "__VITE_ASSET__7602b8b6__"